import React from 'react'
import {Container} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import { faFacebookF, faInstagram, faTwitter } from "@fortawesome/free-brands-svg-icons";
import logo from './../../src/assets/CD Horizontal_whiteFont_opt.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as ROUTES from './Routes'

export default function Footer() {
	return (
		<footer className="main-bg-color footer">
			<Container>
				<div className="text-center py-3">
				<img className="mx-auto foot-logo" src={logo} alt="chore door logo"/>

				</div>
				<div className="row">
					<div className="col py-2">
						
						<p>American Fork, Utah </p>
						
						<p>Email: <span className="footer-email font-weight-bold" onClick={() => window.open(`mailto:info@choredoor.com`)}>info@choredoor.com</span></p>
					</div>
					<div className="col py-2 text-center">
						<ul className="footer-links d-flex flex-column" >
							<li>
								<Link to={ROUTES.LANDING}>
									Home
								</Link>
							</li>
							<li>
								<Link to={ROUTES.PLANS}>
									Plans
								</Link>
							</li>
							<li>
								<Link to={ROUTES.VENDOR_LOGIN}>
									Vendors
								</Link>
							</li>
							<li>
								<Link to={ROUTES.LOGIN}>
									Sign In
								</Link>
							</li>
		
						</ul>
					</div>
					<div className="col py-2">
						<ul className="footer-links d-flex flex-column" >
							<li>
								<Link to={ROUTES.TERMS_AND_CONDITIONS}>
									Terms and Conditions
								</Link>
							</li>
							<li>
								<Link to={ROUTES.PRIVACY_POLICY}>
									Privacy Policy
								</Link>
							</li>
							<li>
								<p>&#169;&nbsp;2021 Chore Door</p>
							</li>
							
						</ul>
					</div>
					<div className="col py-2">
						<div className="row social-media">
							<div className="col text-center ">
							
								<Link to="/" target="_blank">
									<FontAwesomeIcon icon={faFacebookF} className="m-2 fa-2x" />
								</Link>
							</div>
							<div className="col text-center ">
								<Link to="/" target="_blank">
									<FontAwesomeIcon icon={faInstagram} className="m-2 fa-2x"/>
								</Link>
							</div>
							<div className="col text-center ">
								<Link to="/" target="_blank">
									<FontAwesomeIcon icon={faTwitter} className="m-2 fa-2x"/>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</Container>
		</footer>
	)
}
